export default {
  main: {
    title: '中国化学科研院日本分院'
  },
  menu: {
    new: '资讯中心',
    news: '资讯中心',
    newsList: '资讯中心',
    contactUs: '联系我们',
    acti: '业务领域',
    actiEdit: '业务领域',
    about: '关于我们',
    recruit: '职业机会',
    home: '首页',
    technology: '技术研发',
    search: '搜索'
  },
  home: {
    technology: '技术研发',
    technologyName1: '银纳米线透明导电膜',
    technologyName2: '聚酰亚胺',
    technologyName3: '可降解塑料',
    technologyName4: '高效催化剂',
    technologyName5: '氢能储运',
    technologyName6: '微反应器',
    technologyContent1: '高导电性能和透射系数以及良好的耐弯折性能，是柔性显示屏透明导电膜的优良材料。',
    technologyContent2: '优良的化学耐腐蚀性、热力学稳定性及机械性能，被认为是最有前景的高分子材料之一。',
    technologyContent3: '通过太阳光或微生物分解成为低分子物，在自然环境条件下能降解成对环境无害的物质。',
    technologyContent4: '专注环保领域，致力于大气有害成分的高效转化去除，为洁净蓝天贡献力量。',
    technologyContent5: '燃烧热值高、燃烧的产物是水，是世界上最干净的能源。氢能资源丰富且可持续发展。',
    technologyContent6: '采用微反应器的连续流动式反应，可以最大限度地减少副产品，实现节能且操作安全。',
    project: '工程业绩',
    projectName1: '化学工程',
    projectName2: '炼油工程',
    projectName3: '能源工程',
    projectName4: '环保工程',
    projectName5: '轻工 医药 市政',
    projectName5_1: '轻工',
    projectName5_2: '医药 市政',
    projectContent1: '中国化学拥有丰富的化工工程经验，尤其是在传统化工、新型煤化工、石油化工、化工新材料等多个领域掌握并拥有成系列的专利技术和专有技术。可提供从规划、可研、设计、采购、施工、开车等全过程工程服务，工程建设质量均达到国内和国际先进水平。',
    projectContent2: '中国化学是国内最早开展炼油工程设计、建设的企业，参与建设了国内许多大、中型炼油工程项目。',
    projectContent3: '中国化学利用在化学工程技术上的自身优势，在能源储运、电站建设领域同样具有丰富的经验, 在国内外创造了骄人的业绩。',
    projectContent4: '中国化学拥有一支专业的环保技术研发队伍，多次参加省部、国家级科技攻关，具有多项技术，尤其是在国内工业污水治理领域具有丰富的经验。',
    projectContent5: '中国化学利用自身管理、设计、施工的优势，积极参与了港口、道路交通、房屋建筑、轻工、医药、市政等领域的建设，以优良的工程质量贏得了广泛赞誉。',
    news: '资讯中心',
    NewsRelease: '最新动态',
    business: '业务模式',
    subTitle1: '科技易生活',
    subTitle2: '创新益未来'
  },
  about: {
    title: '关于我们',
    name: '中国化学工程股份有限公司',
    name1: '发展历程',
    name2: '组织架构',
    name3: '关于公司',
    name4: '联系我们',
    name5: '会社概况',
    name6: '基本信息',
    developHistory: '中国化学的前身：原国家重工业部成立重工业设计院和建设公司。',
    developHistory1: '以“中国化学工程总公司”的名义在北京注册。',
    developHistory2: '更名为“中国化学工程集团公司”。',
    developHistory3: '在上海证券交易所成功上市,证券简称“中国化学”（代码：601117）。',
    developHistory4: '发布“三年五年规划，十年三十年愿景目标”，把科技和实业列为重要发展战略，同年6月，科研总院和日本分院分别在北京和东京注册成立。',
    // time: '成立时间',
    // local: '所在地',
    // number: '员工数',
    // legal: '法人代表',
    // capital: '注册资本',
    // businessContent: '业务内容',
    // businessContentValue1: '1. 化学、材料、能源、环保、健康等领域相关的技术开发及调研;',
    // businessContentValue2: '2. 上述领域的技术及产品推广、技术咨询、技术成果的授权和转让;',
    // businessContentValue3: '3. 上述领域的产品进出口贸易和代理销售（包含危化品）;',
    // businessContentValue4: '4. 上述领域的企业投资和并购活动;',
    // timeValue: '2019年6月18日',
    lable1: '公司名称',
    lable2: '公司总部',
    lable3: '法人代表',
    lable4: '成立时间',
    lable5: '注册资本',
    lable6: '股东总数',
    lable7: '母公司',
    lable8: '员工数',
    lable9: '业务内容',
    lable10: '主要交易银行',
    tablename1: '中国化学日本综合研究所',
    tablename2: '东京都千代田区丸之内2-3-2',
    tablename3: '执行董事　高小放',
    tablename4: '2019年6月18日',
    tablename5: '4亿9,000万',
    tablename6: '1名（2022年3月末時点）',
    tablename7: '中国化学工程股份有限公司',
    tablename8: '50名（2022年現在）',
    tablename9: '1. 化学、材料、能源、环保、健康等领域相关的技术开发及调研；\n' + 
                '2. 上述领域的技术及产品推广、技术咨询、技术成果的授权和转让；\n' + 
                '3. 上述领域的产品进出口贸易和代理销售（包含危化品）；\n' + 
                '4. 上述领域的企业投资和并购活动；',
    tablename10: '三井住友銀行\n' + '中国建設銀行',
    localValue: '东京办公室〉東京都品川区西五反田8-1-3 PMO五反田10F',
    numberValue: '50人',
    legalValue: '高小放',
    capitalValue: '4亿9000万日元',
    local1: '筑波科研中心：',
    localValue1: '茨城县筑波市东光台5-9-1',
    localValue2: '东京都千代田区丸之内2-3-2',
    telValue2: '03-5220-8899',
    faxValue2: '03-5220-9011',
    tel: '电话',
    telValue: '029-846-3481',
    fax: '传真',
    faxValue: '029-847-4550',
    purpose: '用途',
    purposeValue: '自主研发及共同研发',
    area: '面积',
    areaValue: '1,000 ㎡',
    eMail: '邮箱',
    eMailValue: 'admin@cncec-jri.com',
    eMailValue2: 'admin@cncec-jri.com',
    message: {
      name: '姓名',
      namePinyin: '姓名拼音',
      eMail: '邮箱',
      fax: '传真',
      telephone: '联系方式',
      companyName: '单位名称',
      content: '内容',
      securityCode: '验证码',
      agree: '同意',
      agreeContent: '如果您同意上述个人信息的使用目的以及本公司的隐私政策，请勾选“同意”并点击“发送”按钮。',
      submit: '提交'
    },
    project: {
      title: '8 家工程公司',
      company1: '1. 中国天辰工程有限公司',
      company2: '2. 赛鼎工程有限公司',
      company3: '3. 东华工程科技股份有限公司',
      company4: '4. 中国五环工程有限公司',
      company5: '5. 华陆工程科技有限责任公司',
      company6: '6. 中国成达工程有限公司',
      company7: '7. 中国化学工业桂林工程有限公司',
      company8: '8. 化学工业岩土工程',
    },
    build: {
      title: '10 家建设公司',
      company1: '1. 中化二建集团有限公司',
      company2: '2. 中国化学工程第三建设有限公司',
      company3: '3. 中国化学工程第四建设有限公司',
      company4: '4. 中国化学工程第六建设有限公司',
      company5: '5. 中国化学工程第七建设有限公司',
      company6: '6. 中国化学工程第九建设有限公司',
      company7: '7. 中国化学工程第十一建设有限公司',
      company8: '8. 中国化学工程第十三建设有限公司',
      company9: '9. 中国化学工程第十四建设有限公司',
      company10: '10. 中国化学工程第十六建设有限公司',
    },
    hold: {
      title: '控股参股公司',
      company1: '1. 四川晟达化学新材料有限责任公司',
      company2: '2. 印尼中化巨港电站有限公司',
      company3: '3. 中化工程集团财务有限公司',
      company4: '4. 中化工程集团环保有限公司',
      company5: '5. 中国化学科学技术研究院',
    },
    contact: {
      address: '办公地址:',
      tell: '电 话:',
      addressName: '〒141-0031 東京都品川区西五反田8丁目1-3  PMO五反田 10F 株式会社アクテイ。',
      phone: '03-57192660'
    }
  },
  acti: {
    title: '业务领域',
    name: '中国化学科研院日本分院',
    name3: '筑波科研中心',
    name1: '据点介绍',
    name2: 'ACTI业务模式',
    name4: '东京事务所',
    name5: '横滨研发中心',
    businessName1: '新材料',
    businessContent1: '工程塑料 特种橡胶 电子化学品',
    businessName2: '清洁能源',
    businessContent2: '氢能 太阳能 生物能',
    businessName3: '绿色环保',
    businessContent3: '三废处理 碳中和 可降解塑料',
    businessName4: '石化新技术',
    businessContent4: '节能降耗 智能化装备',
    modeName1: '技术引进',
    modeContent1: '定位填补国内空白和国内亟待升级换代的产品和技术，以技术合作的方式引进技术。',
    modeName2: '联合开发',
    modeContent2: '与日本当地工业科技企业及高校科研机构合作的共同开发课题。',
    modeName3: '自主研发',
    modeContent3: '着眼未来技术发展趋势，布局下一代产品和技术，培育自主技术。',
    modeName4: '投资并购',
    modeContent4: '对日本行业内相关的初创技术公司进行并购。',
    content: '<b style="width: 114px">成立时间：</b>2019年6月18日<br>' +
              '<div class="d-flex"><b style="width: 114px">所在地：</b><p>东京办公室〉東京都品川区西五反田8-1-3 PMO五反田10F</p></div><br>' +
              '<b style="width: 114px">员工数：</b>45人<br>' +
              '<b style="width: 114px">法人代表：</b>高小放<br>' +
              '<b style="width: 114px">注册资本：</b>4億9000万日元<br>'
  },
  recruit: {
    title: '职业机会',
    info: '招聘职位',
    name: '职位名称',
    local: '工作地点',
    number: '招聘人数',
    time: '更新时间',
    rank: '职级',
    numberPeople: '管理人数',
    numberManagers: '所属部门',
    supervisor: '上级主管',
    arriveTime: '希望到岗时间',
    applyNow: '立即申请',
  },
  news: {
    title: '资讯中心',
    allNews: '全部资讯',
    newsRelease: '资讯信息'
  },
  newsList: {
    title: '资讯中心'
  },
  organizational: {
    title: 'ACTI筑波实验室',
    name: '实验室外部和内部'
  },
  search: {
    name: '搜索结果',
    title: '搜索',
    btn: '搜索',
    noInfo: '暂无搜索信息',
  },
  project: {
    title: '工程业绩',
    project1: '神华MTO项目',
    project2: '拜尔TDI项目',
    project3: '越南尿素合成氨项目',
    project4: '福建己内酰胺项目',
    project5: '新疆独山子炼油项目',
    project6: '巴基斯坦柴油加氢',
    project7: '上海LNG接收站项目',
    project8: '格鲁吉亚联合循环电站',
    project9: '上海废料焚烧处理项目',
    project10: '内蒙古神华CCS项目',
    project11: '缅甸造纸厂项目',
    project12: '诺和诺德生物制药厂项目',
  },
  business: {
    technology: '技术合作',
    joint: '联合开发',
    independent: '自主研发',
    investment: '投资并购',
    technologyContent: '瞄准中国市场亟待升级换代的产品和技术，与当地企业通过技术合作共享市场',
    jointContent: '与高校科研机构及工业科技企业展开深度合 作，共有知识产权、促进成果转化',
    independentContent: '着眼未来市场发展趋势，布局下一代产品和 技术，培育自有技术和产品工艺',
    investmentContent: '对先进技术领域的初创公司开展投资活动',
  },
  technology: {
    title: '技术研发'
  },
  footer: {
    help: {
      title: '为你提供协助... ...',
      question: '常见问题',
      answers: '',
      contactNow: '立即联系',
      phone: '电话联系',
      process: '如果您对我们的服务或流程感到不满意，有任何意见或投诉，请与通过以下方式与我们联系',
      links: '友情链接:',
      contactUs: '联系我们',
      tel: '电话: ',
      fax: '传真: ',
      eMail: '邮箱: ',
    },
    confirm: '我知道了',
    privacyPolicy: '隐私条款'
  },
  common: {
    building: '筹建中',
    viewDetails: '查看详情',
    more: '更多',
    contact: '联系我们',
    searchTitle: '请输入搜索标题',
    phoneNotEmpty: '手机号不能为空',
    pleaseEnterPhone: '请输入正确的手机号',
    pleaseEnterContent: '请输入内容',
    pleaseEnterSecurityCode: '请输入验证码',
    submitSuccess: '提交成功',
    verificationCodeError: '验证码错误'
  }
}



// WEBPACK FOOTER //
// ./src/lang/cn.js